// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,html {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: rgb(33, 37, 41) !important;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

a {
  color: inherit !important;
  text-decoration: none !important;
}

.cursor-pointer {
  cursor: pointer;
}

.zoom-shadow:hover {
  transform: scale(1.01) translate3d(0,-1px,0);
  box-shadow: 0 4px 20px black;
}

.zoom-shadow:active {
  transform: scale(.99);
  transition-duration: .05s;
  box-shadow: none;
}

.zoom-shadow {
  transition: all .1s ease-in-out;
  border-radius: 8px;
}


.dateinputview {
  font-size: 20px;
  border: 0;
  background: none;
  font-weight: bold;
  color : white;
  text-align: center;
  color-scheme: dark;
  width: -moz-fit-content;
  width: fit-content;
}
/* input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
} */

input[type="checkbox"]:checked {
  background-color: rgb(33, 37, 41);
}

.dayreport_view2 > *:nth-child(6),
.dayreport_view2 > *:nth-child(7),
.dayreport_view2 > *:nth-child(11),
.dayreport_view2 > *:nth-child(12),
.dayreport_view2 > *:nth-child(16),
.dayreport_view2 > *:nth-child(17),
.dayreport_view2 > *:nth-child(22),
.dayreport_view2 > *:nth-child(23),
.dayreport_view2 > *:nth-child(26),
.dayreport_view2 > *:nth-child(27)
{
  display: none;
}




@media print
{    
    .no-print, .no-print *
    {
        display: none !important;
    }

    table tbody tr td,
    table tbody tr th {
      page-break-inside:avoid !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE;aACW;AACb;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EAEE,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;;AAGA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;AACA;;;;GAIG;;AAEH;EACE,iCAAiC;AACnC;;AAEA;;;;;;;;;;;EAWE,aAAa;AACf;;;;;AAKA;;IAEI;;QAEI,wBAAwB;IAC5B;;IAEA;;MAEE,kCAAkC;IACpC;AACJ","sourcesContent":["body,html {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: rgb(33, 37, 41) !important;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\na {\n  color: inherit !important;\n  text-decoration: none !important;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.zoom-shadow:hover {\n  -webkit-transform: scale(1.01) translate3d(0,-1px,0);\n  transform: scale(1.01) translate3d(0,-1px,0);\n  box-shadow: 0 4px 20px black;\n}\n\n.zoom-shadow:active {\n  -webkit-transform: scale(.99);\n  transform: scale(.99);\n  transition-duration: .05s;\n  box-shadow: none;\n}\n\n.zoom-shadow {\n  transition: all .1s ease-in-out;\n  border-radius: 8px;\n}\n\n\n.dateinputview {\n  font-size: 20px;\n  border: 0;\n  background: none;\n  font-weight: bold;\n  color : white;\n  text-align: center;\n  color-scheme: dark;\n  width: fit-content;\n}\n/* input[type=\"date\"]::-webkit-inner-spin-button,\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n    display: none;\n    -webkit-appearance: none;\n} */\n\ninput[type=\"checkbox\"]:checked {\n  background-color: rgb(33, 37, 41);\n}\n\n.dayreport_view2 > *:nth-child(6),\n.dayreport_view2 > *:nth-child(7),\n.dayreport_view2 > *:nth-child(11),\n.dayreport_view2 > *:nth-child(12),\n.dayreport_view2 > *:nth-child(16),\n.dayreport_view2 > *:nth-child(17),\n.dayreport_view2 > *:nth-child(22),\n.dayreport_view2 > *:nth-child(23),\n.dayreport_view2 > *:nth-child(26),\n.dayreport_view2 > *:nth-child(27)\n{\n  display: none;\n}\n\n\n\n\n@media print\n{    \n    .no-print, .no-print *\n    {\n        display: none !important;\n    }\n\n    table tbody tr td,\n    table tbody tr th {\n      page-break-inside:avoid !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
